import Address from './Address';

export default class Mortgagee {
	public id: string | null = null;
	public lienPositionNumber: number | null = null;
	public name: string | null = null;
	public loanNumber: string | null = null;
	public mailingAddress: Address | null = null;
	public includeAsTheirInterestsMayAppear: boolean | null = null;
	public includeItsSuccessorsAndOrAssigns: boolean | null = null;
	public billMortgagee: boolean | null = null;
	public coverageRequiredByMortgagee: boolean | null = null;
	public email: string | null = null;
	public sendPaymentReceiptToEmail: boolean | null = null;

	public constructor() {

	}
};